const CACHE_TIME = {
    FIVE_MIN: 5 * 60 * 1000, // 300,000ms
    FIFTEEN_MIN: 15 * 60 * 1000, // 900,000ms
    THIRTY_MIN: 30 * 60 * 1000, // 1,800,000ms
    ONE_HOUR: 60 * 60 * 1000, // 3,600,000ms
    ONE_DAY: 24 * 60 * 60 * 1000, // 86,400,000ms
};

// Both default and named exports — older code uses the default import,
// newer code prefers the named export.
export { CACHE_TIME };
export default CACHE_TIME;
